import { render } from "./LocaleTabs.vue?vue&type=template&id=19045b85"
import script from "./LocaleTabs.vue?vue&type=script&lang=js"
export * from "./LocaleTabs.vue?vue&type=script&lang=js"

import "./LocaleTabs.vue?vue&type=style&index=0&id=19045b85&lang=scss"

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"LocaleTabs.vue"]])

export default __exports__